// extracted by mini-css-extract-plugin
module.exports = {"title":"title--e47a9","text":"text--84e12"};